
interface Config {
  SENTRY_PUBLIC_DSN: string;
  SENTRY_RELEASE: string;
  FORCE_REPORT_TO_SENTRY: string;
  SUPPORT_EMAIL: string;
}

const config: Config = {
  FORCE_REPORT_TO_SENTRY: process.env.FORCE_REPORT_TO_SENTRY,
  SENTRY_PUBLIC_DSN: process.env.SENTRY_PUBLIC_DSN,
  SENTRY_RELEASE: process.env.SENTRY_RELEASE,
  SUPPORT_EMAIL: process.env.SUPPORT_EMAIL
};

export const isDevelopment = window.location.hostname.search('localhost') === 0 ||
  window.location.hostname.search('127.0.0.1') === 0 ||
  window.location.hostname.search('nginx') === 0 ||
  window.location.hostname.search('ngrok') === 0;

export const isProduction = window.location.hostname === 'www.coolcampuschallenge.org' ||
  window.location.hostname === 'prd.coolcampuschallenge.org';

const hostname = window.location.hostname;
export const isStaging = hostname === 'stg.coolcampuschallenge.org' ||
  hostname.indexOf('ccn-stg-ui') === 0 ||
  (hostname.indexOf('stg') !== -1 && hostname.indexOf('.run.app') !== -1);

/** Third-party analytics (GA / Intercom) only load on production hostnames. */
export const isAnalyticsEnabled = isProduction;

export const isIOS = Boolean(navigator.platform) && /iPad|iPhone|iPod/.test(navigator.platform);

export default {
  config,
  isDevelopment
};
